export enum STORE_ID {
  HUA_SHI = 20,
  TI_YU_XI_LU = 22,
  ZHU_JIANG_XIN_CHENG = 18,
  GUANG_ZHOU_DONG_ZHAN = 16,
  WU_YANG = 21,
  KE_CUN = 17,
  TAO_JING = 19,
  YUE_XIU_GONG_YUAN = 25,
  HANG_XI_CHANG_LONG = 23
}
